import {
  Arrange,
  Button,
  Container,
  Split,
  SplitSection,
  Text,
  TextButton,
} from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import { setShowBlockedNotificationsModal } from 'actions/notification-settings';
import {
  CLICKED_ALLOW_NOTIFICATIONS,
  CLICKED_DISMISS_NOTIFICATIONS,
  REQUEST_PERMISSIONS_RESULT,
} from 'constants/events';
import {
  PERMISSION_DENIED,
  PERMISSION_GRANTED,
  PUSH_ACTIVATION_SETTINGS,
} from 'constants/notifications';
import { REQUEST_PUSH_PERMISSIONS } from 'constants/triggers';
import { postUpdateNotificationSettings } from 'creators/notification-settings';
import { completeTriggerCreator } from 'creators/triggers';
import * as analytics from 'utilities/analytics';
import { setupPushNotifications } from 'utilities/notifications';

import { useUrlTriggerReset } from 'hooks/triggers';

import { useBackfillPushToken } from '../hooks/useBackfillPushToken';

import BlockedNotificationsModal from 'components/blocked-notifications-modal';

import styles from './styles.module.less';

const WebPermissionsBanner = () => {
  const dispatch = useDispatch();

  useBackfillPushToken();

  useUrlTriggerReset({
    paramName: 'permissionsOverride',
    trigger: REQUEST_PUSH_PERMISSIONS,
  });

  const onClickAllow = () => {
    analytics.track(CLICKED_ALLOW_NOTIFICATIONS, {
      location: 'sharePage',
    });

    setupPushNotifications('sharePage').then(result => {
      analytics.track(REQUEST_PERMISSIONS_RESULT, {
        location: 'sharePage',
        result,
      });

      if (result === PERMISSION_DENIED) {
        dispatch(setShowBlockedNotificationsModal(true));

        return;
      }

      if (result === PERMISSION_GRANTED) {
        dispatch(postUpdateNotificationSettings(PUSH_ACTIVATION_SETTINGS));
      }

      dispatch(completeTriggerCreator(REQUEST_PUSH_PERMISSIONS));
    });
  };

  const onClickDismiss = () => {
    // Fade out and then fire action
    dispatch(completeTriggerCreator(REQUEST_PUSH_PERMISSIONS));

    analytics.track(CLICKED_DISMISS_NOTIFICATIONS, {
      location: 'sharePage',
    });
  };

  return (
    <Container
      radius="medium"
      backgroundColor="blurpleLight"
      className={styles.permissionsBanner}
    >
      <BlockedNotificationsModal location="sharePage" />
      <Split gap="medium" justifyContent="space-between">
        <SplitSection grow={1} basis={72}>
          <Text>
            <strong>🔔 Turn on notifications</strong> to know when your video
            has been watched and interacted with.
          </Text>
        </SplitSection>
        <SplitSection>
          <Arrange gap="small">
            <Button onClick={() => onClickAllow()}>Allow notifications</Button>
            <TextButton onClick={() => onClickDismiss()}>Dismiss</TextButton>
          </Arrange>
        </SplitSection>
      </Split>
    </Container>
  );
};

export default WebPermissionsBanner;
